import { TOGGLE_LOG_IN_STATUS } from '../actionTypes';

export const toggleLogInStatus = status => ({
  type: TOGGLE_LOG_IN_STATUS,
  status
});




// WEBPACK FOOTER //
// ./src/store/actions/authenticationActions/toggleLogInStatus.js